import { render, staticRenderFns } from "./DuplicateModels.vue?vue&type=template&id=bc378d9a"
import script from "./DuplicateModels.vue?vue&type=script&lang=js"
export * from "./DuplicateModels.vue?vue&type=script&lang=js"
import style0 from "./DuplicateModels.vue?vue&type=style&index=0&id=bc378d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports